import React from 'react';
import PropTypes from 'prop-types';

const MessagesPath = ({ fill }) => {
  return (
    <path
      fill={fill}
      d="M13.5 3h7a8.5 8.5 0 0 1 3.566 16.219l1.16 3.89a.5.5 0 0 1-.772.548L19.383 20H13.5a8.5 8.5 0 1 1 0-17zM3 20c0-1.355.449-2.605 1.206-3.609A10.501 10.501 0 0 0 13.5 22h5.238l1.438 1.037A5.998 5.998 0 0 1 15 26H9.714l-3.931 2.691a.5.5 0 0 1-.76-.562l.93-2.96A5.994 5.994 0 0 1 3 20z"
    />
  );
};

MessagesPath.propTypes = {
  fill: PropTypes.string,
};

export default MessagesPath;



// WEBPACK FOOTER //
// ./src/icon/svgs/features-navigation/messages.jsx